<template>
  <div v-loading="emailParam && loading">
    <br>
    <h1>新規ペットオーナー登録</h1>
    <br>
    <el-form :model="form" :rules="rules" ref="form" @submit.native.prevent>
      <table width="100%" border="0" style="font-size:15px;line-height:1.5em;">
        <tr v-if="!emailParam && sendMailSuccessMsg">
          <td>
            <div style="white-space: pre-line;">{{ sendMailSuccessMsg }}</div>
          </td>
        </tr>
        <tr v-if="emailParam && !isToVisible">
          <td>
            <el-form-item label="" prop="toId">
              <el-select v-model="form.toId" placeholder="" filterable>
                <el-option
                  v-for="item in afterLoadingToList"
                  :key="item.toId"
                  :label="item.toName"
                  :value="item.toId">
                </el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr v-if="emailParam">
          <td>
            <el-form-item label="部屋番号" prop="roomNumber">
              <el-input v-model="form.roomNumber" :disabled="form.roomIdDisabled" autocomplete="off" placeholder="半角英数字8桁以内" maxlength="8"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr v-if="emailParam">
          <td>
            <el-form-item label="ペットオーナ氏名" prop="userName">
              <el-input v-model="form.userName" autocomplete="off" placeholder="64桁以内" maxlength="64" @input="filterSpecialChars"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr v-if="emailParam">
          <td>
            <el-form-item label="電話番号" prop="tel">
              <el-input v-model="form.tel" autocomplete="off" placeholder="半角数字11桁以内「ハイフン(-)なし」" maxlength="11"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr v-if="!sendMailSuccessMsg">
          <td>
            <el-form-item label="メールアドレス" prop="email">
              <el-input
                v-model="form.email"
                autocomplete="off"
                placeholder="xxx@xxx.xxx"
                maxlength="64"
                :disabled="emailParam"
              ></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr v-if="emailParam">
          <td>
            <el-form-item label="パスワード" prop="password">
              <el-input v-model="form.password" autocomplete="off" placeholder="半角英数字大文字小文字含む8桁" maxlength="8" type="password"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr v-if="emailParam">
          <td>
            <el-form-item label="パスワード(再入力)" prop="confirmPassword">
              <el-input v-model="form.confirmPassword" autocomplete="off" placeholder="半角英数字大文字小文字含む8桁" maxlength="8" type="password"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <td>
            <el-button v-if="!emailParam && !sendMailSuccessMsg" type="warning" @click="sendMail">送信</el-button>
            <el-button v-if="emailParam" type="warning" @click="onSubmit">利用申込</el-button>
          </td>
        </tr>
      </table>
      <br><br>
    </el-form>
  </div>
</template>

<script>
import request from '@/utils/request';
import { Message } from 'element-ui';

export default {
  name: 'OwnerRigest',
  inject: ['manshonId', 'toList'],
  data() {
    return {
      loading: true,
      isToVisible: false,
      url: window.location.href,
      form: {
        toId: '',
        roomNumber: '',
        roomIdDisabled: false,
        userName: '',
        tel: '',
        email: '',
        password: '',
        confirmPassword: '',
      },
      manshonId: this.manshonId(),
      rules: {
        toId: [
          { required: true, message: '必須です。', trigger: 'change' },
        ],
        // roomNumber: [
        //   { required: true, message: '必須です。', trigger: 'blur' },
        //   { pattern: /^[a-zA-Z0-9]{1,8}$/, message: '半角英数字8桁以内で入力してください。', trigger: 'blur' },
        // ],
        userName: [
          { required: true, message: '必須です。', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '必須です。', trigger: 'blur' },
          { pattern: /^[0-9]{1,11}$/, message: '半角数字11桁以内「ハイフン(-)なし」で入力してください。', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '必須です。', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: '無効なメールアドレスです。', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '必須です。', trigger: 'blur' },
          { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9]{8}$/, message: '半角英数字大文字小文字含む8桁で入力してください。', trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, message: '必須です。', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.password) {
                callback(new Error('パスワードと一致しません。'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },
      emailParam: '',
      roomIdParam: '',
      sendMailSuccessMsg: '',
    };
  },
  created() {
    // URLからemailパラメータ取得
    this.emailParam = new URLSearchParams(window.location.search).get('email');
    if (this.emailParam) {
      this.form.email = this.emailParam;
    }
    this.roomIdParam = new URLSearchParams(window.location.search).get('roomId');
    if (this.roomIdParam) {
      this.form.roomIdDisabled = true; // フォームの部屋番号を無効化
      this.form.roomNumber = this.roomIdParam;
    } else {
      this.form.roomIdDisabled = false; // フォームの部屋番号を有効化
      this.form.roomNumber = '';
    }
  },
  computed: {
    afterLoadingToList() {
      const list = this.toList();
      // データ返却後のローディングを閉じる
      if (Array.isArray(list)) {
        this.loading = list.length === 0;
        if (list.length === 1 && list[0].toId === '00') {
          this.form.toId = list[0].toId;
          this.isToVisible = true;
        } 
      }
      return list;
    }
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 60000);
  },
  methods: {
    // メール送信
    sendMail() {
      // メールアドレスのみバリデーション
      this.$refs.form.validateField('email', (msg) => {
        if (!msg) {
          request('sendMail', { url: this.url, email: this.form.email, manshonId: this.manshonId}).then((res) => {
            this.sendMailSuccessMsg = res.msg;
          });
        }
      });
    },
    // 利用申込
    async onSubmit() {
      // mailパラメータ有無に関わらず全項目バリデーション
      this.$refs.form.validate((valid) => {
        if (valid) {
          request('ownerRigest', {
            manshonId: this.manshonId,
            toId: this.form.toId,
            roomId: this.form.roomNumber,
            userName: this.form.userName,
            loginId: this.manshonId + this.form.toId + this.form.roomNumber,
            tel: this.form.tel,
            email: this.form.email,
            userPassword: this.form.password,
          }).then((res) => {
            Message.success(res.msg);
            this.goOwnerlogin();
          });
        }
      });
    },
    filterSpecialChars(value) {
      this.form.userName = value.replace(/[^\u4e00-\u9fa5\u3040-\u309f\u30a0-\u30ff\u31f0-\u31ffa-zA-Z0-9]/g, '');
    },
    // ログインへ遷移
    goOwnerlogin() {
      this.$router.push({
        path: '/login',
      }).catch(() => {});
    },
  },
};
</script>

<style lang="less">
  html, body {
    overflow-x: hidden; // 横スクロールを防止
    width: 100%;        // 幅を100%に設定
  }
  h1 {
    padding-top: 10em;
    padding: 0.25em 0.5em;
    color: #494949;
    background: transparent;
    border-left: solid 5px #7db4e6;
  }

  th, td {
    border: solid 0px;
    padding: 10px;
  }

  option {
    height: 10px;
    width: 250px;
  }

  .commonTable {
    width: 100%;
    text-align: center;
    border-collapse: collapse;
    border-spacing: 0;
    border: solid 2px #778ca3;
  }
  .commonTable th {
    padding: 10px;
    background: #e9faf9;
    border: solid 1px #778ca3;
    border-bottom: solid 2px #778ca3;
  }
  .commonTable td {
    padding: 10px;
    border-left: solid 1px #778ca3;
  }
  .commonTable tr {
    border-top: dashed 1px #778ca3;
  }
</style>
